export const SCHEDULED_BREAKS = 'scheduled-breaks';

export const DAYS = Object.freeze(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']);

export const PERIODS = Object.freeze({
    DAILY: 'daily',
    WEEKLY: 'weekly',
    ONETIME: 'onetime'
});

export const FORMAT_TO_SAVE = 'yyyy-MM-dd';

export const TABS = Object.freeze({
    TIME: 'time',
    DAY: 'day',
    DATE: 'date'
});

export const TIME_FORMATS = Object.freeze({
    LONG: '24-hour',
    SHORT: '12-hour'
});

export const DAY_PERIOD = Object.freeze({
    AM: 'AM',
    PM: 'PM'
});
